
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderDetailedReportGrid extends Serenity.EntityGrid<OrderDetailedReportRow, any> {
        protected getColumnsKey() { return OrderDetailedReportColumns.columnsKey; }
        protected getDialogType() { return OrderDetailedReportDialog; }
        protected getIdProperty() { return OrderDetailedReportRow.idProperty; }
        protected getInsertPermission() { return OrderDetailedReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderDetailedReportRow.localTextPrefix; }
        protected getService() { return OrderDetailedReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderDetailedReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}